<template>
  <v-card class="content-bg pa-4 mx-auto custom-card" max-width="300" elevation="0" outlined v-if="node">
    <v-card-actions>
      <v-btn v-if="nodeData.type != 'generic'" fab x-small elevation="0">
        <v-icon>{{ icon }}</v-icon>
      </v-btn>
      <v-btn @click="editIconDialog = true" v-else fab x-small elevation="0">
        <v-icon>{{ icon }}</v-icon>
      </v-btn>
      <span class="ml-1 text-overline text-truncate">{{ nodeData.type != 'generic' ? nodeData.technique : ''
      }}</span>
      <v-spacer></v-spacer>
      <flowy-drag-handle v-if="nodeData.type != 'start' && !staticMode">
        <v-btn text small elevation="0">
          <v-icon>mdi-drag</v-icon>
        </v-btn>
      </flowy-drag-handle>
    </v-card-actions>
    <div class="text-node">
      <v-card-title class="primary--text text-subtitle-1 clickable" @click="editNode">
        <span>{{ nodeData.title }}</span>
      </v-card-title>
      <div v-html="nodeData.description" class="text-caption clickable node-desc" @click="editNode"></div>
      <v-card-text class="pl-4" v-if="nodeData.adminVideo">
        <div class="text-left">
          <v-icon color="primary">mdi-video-outline</v-icon>
          {{ nodeData.adminVideo.title }}
        </div>
        <div class="image-container">
          <ImageDisplay :src="videoThumbnail"></ImageDisplay>
        </div>
      </v-card-text>
      <v-card-text class="pl-4" v-else-if="nodeData.videoUrl">
        <iframe frameborder="0" width="100%" class="node-image" :src="embedVideoUrl(nodeData.videoUrl)">
        </iframe>
      </v-card-text>
      <v-card-text v-else-if="nodeData.imageUrl">
        <div class="image-container">
          <ImageDisplay :src="nodeData.imageUrl"></ImageDisplay>
        </div>
      </v-card-text>
    </div>
    <v-divider class="my-4 mx-4" v-if="nodeData.type != 'start'"></v-divider>
    <v-card-actions class="pb-0 mb-0" v-if="nodeData.type != 'start'">
      <v-btn class="newbtn pa-4" v-if="!nodeData.adminVideo" small icon @click="editImageDialog = true">
        <v-icon>mdi-image-edit-outline</v-icon>
      </v-btn>
      <v-btn class="newbtn pa-4" v-if="!nodeData.imageUrl" small icon @click="addVideo()">
        <v-icon>mdi-video-plus-outline</v-icon>
      </v-btn>
      <v-spacer></v-spacer>
      <v-btn v-if="!staticMode" small icon @click="remove()">
        <v-icon>mdi-delete-outline</v-icon>
      </v-btn>
    </v-card-actions>

    <v-dialog v-model="editIconDialog" max-width="600px">
      <v-card flat v-if="node" class="pb-4 pt-12 px-4">
        <v-card-text>
          <v-select clearable outlined dense v-model="alternativeIcon" :items="alternativeIcons" item-text="text"
            item-value="icon" return-object persistent-placeholder prepend-inner-icon="mdi-menu-down">
            <template v-slot:selection="{ item }">
              <v-icon left>{{ item.icon }}</v-icon>
              <span>{{ item.text }}</span>
            </template>

            <template v-slot:item="{ item }">
              <v-list-item-icon>
                <v-icon>{{ item.icon }}</v-icon>
              </v-list-item-icon>
              <v-list-item-content>
                <v-list-item-title>{{ item.text }}</v-list-item-title>
              </v-list-item-content>
            </template>
          </v-select>
        </v-card-text>
        <v-card-actions>
          <v-btn outlined elevation="0" color="primary" @click="editIconDialog = false">
            <v-icon class="mr-1">mdi-check-circle-outline</v-icon>
            {{ $t("message.update") }}
          </v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>
    <v-dialog v-model="editNodeDialog" max-width="600px">
      <v-card flat v-if="node" class="pb-4 pt-12 px-4">
        <v-card-text>
          <v-form ref="forma" lazy-validation>
            <v-row>
              <v-col cols="12">
                <v-text-field v-model="nodeData.title" :label="$t('message.title')" outlined
                  hide-details></v-text-field>
              </v-col>
              <v-col cols="12">
                <v-textarea v-model="nodeData.description" :label="$t('message.description')" rows="5" outlined
                  hide-details></v-textarea>
              </v-col>
            </v-row>
          </v-form>
        </v-card-text>
        <v-card-actions>
          <v-btn outlined elevation="0" color="primary" @click="editNodeDialog = false">
            <v-icon class="mr-1">mdi-check-circle-outline</v-icon>
            {{ $t("message.update") }}
          </v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>
    <v-dialog v-model="editVideoDialog" max-width="600px">
      <v-card flat v-if="node" class="pb-4 pt-12 px-4">
        <v-card-text>
          <v-autocomplete :disabled="nodeData.videoUrl ? true : false" v-model="nodeData.adminVideo"
            :return-object="true" :items="availableVideos" item-text="title" :label="$t('message.video')" outlined
            hide-details :clearable="true" @change="selectVideo()">
          </v-autocomplete>
          <v-text-field class="mt-1" :disabled="nodeData.adminVideo ? true : false" v-model="nodeData.videoUrl"
            :label="$t('message.video_url')" outlined hide-details></v-text-field>
        </v-card-text>
        <v-card-actions>
          <v-btn outlined elevation="0" class="ml-2" color="primary" @click="checkYoutubeVideo()">
            {{ $t('message.add') }}
          </v-btn>
          <v-btn elevation="0" class="ml-2 cancel-button"
            @click="nodeData.adminVideo = null; videoThumbnail = null; editVideoDialog = false">
            {{ $t('message.close') }}
          </v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>
    <v-dialog persistent v-model="editImageDialog" max-width="600px">
      <v-card flat v-if="node" class="pb-4 pt-4 px-4">
        <div v-if="uploadingImage" class="mt-1 mb-2">
          <v-progress-linear buffer-value="5" color="success" height="15" stream :value="uploadPercentage">
          </v-progress-linear>
        </div>
        <v-card-text>
          <div v-if="nodeData.imageUrl" class="image-container">
            <ImageDisplay class="align-center" :src="nodeData.imageUrl">
            </ImageDisplay>
          </div>
          <input type="file" ref="addPostImageEl" v-show="false" @change="uploadNewImage" accept="image/*" />
        </v-card-text>
        <v-card-actions>
          <v-btn :loading="uploadingImage" small color="primary" outlined elevation="0" @click="clickNodeImageField()">
            <v-icon size="20">mdi-image-outline</v-icon>
            <span v-if="!isSmallerDisplay()" class="ml-1">{{ nodeData.imageUrl ? $t("message.edit") :
              $t("message.add_image") }}</span>
          </v-btn>
          <v-btn elevation="0" :disabled="!nodeData.imageUrl && !newNodeImage" color="error"
            @click="nodeData.imageUrl = null;">
            {{ $t('message.remove') }}
          </v-btn>
          <v-btn elevation="0" class="ml-2" @click="editImageDialog = false" :disabled="uploadingImage">
            {{ $t('message.close') }}
          </v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>
  </v-card>
</template>
<script>
import Api from "@/services/Api2";

export default {
  name: "DemoNode",
  data() {
    return {
      text: 'This is component A',
      icon: 'mdi-coffin',
      newNodeImage: null,
      uploadingImage: false,
      videoThumbnail: null,
      editNodeDialog: false,
      editImageDialog: false,
      editVideoDialog: false,
      uploadPercentage: null,
      editIconDialog: null,
      availableVideos: [],
      nodeData: null,
      alternativeIcon: null,
      alternativeIcons: []
    }
  },
  props: ['remove', 'node', 'type', 'videos', 'staticMode'],
  created() {
    this.nodeData = this.node;
    if (this.videos && this.videos.length > 0)
      this.availableVideos = this.videos;
    let type = this.nodeData.type;
    let alternativeIcon = this.nodeData.nodeIcon;
    if (!type)
      type = this.nodeData.data.n.type
    if (alternativeIcon && alternativeIcon.source == 'mdi') {
      this.icon = alternativeIcon.value;
    } else if (type) {
      if (type == 'submission')
        this.icon = 'mdi-crosshairs-gps';
      else if (type == 'pass')
        this.icon = 'mdi-arrow-decision-outline';
      else if (type == 'mount')
        this.icon = 'mdi-arrow-collapse-down';
      else if (type == 'side-control')
        this.icon = 'mdi-selection-ellipse-arrow-inside';
      else if (type == 'sweep')
        this.icon = 'mdi-cached';
      else if (type == 'back')
        this.icon = 'mdi-arrange-send-backward';
      else if (type == 'start')
        this.icon = 'mdi-ray-start-arrow';
      else if (type == 'takedown')
        this.icon = 'mdi-arrow-down-right';
      else if (type == 'transition')
        this.icon = 'mdi-transition-masked';
      else if (type == 'guard')
        this.icon = 'mdi-shield-half-full';
      else if (type == 'standup')
        this.icon = 'mdi-arrange-send-to-back';
      else if (type == 'escape')
        this.icon = 'mdi-lock-open-check-outline';
      else if (type == 'generic')
        this.icon = 'mdi-hexagon-multiple-outline';
    }
    if (!this.videos || this.videos.length == 0)
      this.availableVideos = this.nodeData.videos;
    if (this.nodeData.adminVideo) {
      this.videoThumbnail = this.nodeData.adminVideo.thumbnail;
    }
    //Setup alt icons
    this.alternativeIcons.push({ icon: 'mdi-karate', text: this.$t('message.kick') });
    this.alternativeIcons.push({ icon: 'mdi-mixed-martial-arts', text: this.$t('message.punch') });
    this.alternativeIcons.push({ icon: 'mdi-walk', text: this.$t('message.stand') });
    this.alternativeIcons.push({ icon: 'mdi-fencing', text: this.$t('message.attack') });
    this.alternativeIcons.push({ icon: 'mdi-security', text: this.$t('message.block') });
    this.alternativeIcons.push({ icon: 'mdi-arm-flex-outline', text: this.$t('message.elbow') });
    this.alternativeIcons.push({ icon: 'mdi-rotate-left-variant', text: this.$t('message.slip') });
    this.alternativeIcons.push({ icon: 'mdi-handshake', text: this.$t('message.clinch') });
  },
  watch: {
    alternativeIcon: {
      handler: function (newValue) {
        if (!newValue) {
          this.icon = 'mdi-hexagon-multiple-outline'
        } else {
          this.icon = newValue.icon;
          this.nodeData.nodeIcon = { source: 'mdi', value: newValue.icon };
        }
      }
    }
  },
  methods: {
    checkYoutubeVideo() {
      if (this.nodeData.videoUrl) {
        let url = this.embedVideoUrl(this.nodeData.videoUrl);
        if (url)
          this.editVideoDialog = false;
        else
          this.showAlert('error', this.$t('message.invalid_youtube_video'));
      } else {
        this.editVideoDialog = false;
      }
    },
    selectVideo() {
      this.videoThumbnail = null;
      const adminVideo = this.nodeData.adminVideo._id;
      for (const v of this.availableVideos) {
        if (v._id == adminVideo) {
          this.videoThumbnail = v.image;
          break;
        }
      }
    },
    clickNodeImageField() {
      const imageFileBtn = this.$refs.addPostImageEl;
      if (imageFileBtn) {
        imageFileBtn.click();
      }
    },
    editNode() {
      this.editNodeDialog = true;
    },
    addVideo() {
      this.editVideoDialog = true;
    },
    onUploadProgress(progressEvent) {
      const percent = parseInt(Math.round((progressEvent.loaded / progressEvent.total) * 100));
      if (percent >= 97)
        this.uploadPercentage = 97;//Stay on 97
      else
        this.uploadPercentage = percent;
    },
    async uploadNewImage(event) {
      this.uploadingImage = true;
      try {
        const selectedFile = event.target.files[0];
        const formData = new FormData();
        const d = new Date();
        const millis = d.getTime();
        const imgExtension = selectedFile.type.toLowerCase().split('/')[1];
        const blob = new Blob([selectedFile], { type: selectedFile.type });
        formData.append("image", blob, 'bjjlink-user-admin-uploaded-image-' + millis + '.' + imgExtension);
        const res = await Api().post("content/image/admin", formData, {
          headers: {
            "Content-Type": "multipart/form-data",
          },
          onUploadProgress: this.onUploadProgress,
        });
        if (res) {
          const data = res.data;
          if (data) {
            const vm = this;
            setTimeout(function () {
              vm.nodeData.imageUrl = data.location;
              vm.uploadingImage = false;
              vm.editImageDialog = false;
              vm.showAlert('success', this.$t('message.update_to_confirm'));
            }, 4000);
          }
        } else {
          this.uploadingImage = false;
          this.showAlert('error', this.$t('message.oops_not_working'));
        }
      } catch (error) {
        console.log(error);
        this.uploadingImage = false
        this.editImageDialog = false;
        this.showAlert('error', this.$t('message.oops_not_working'));
      }
    },
    truncateText(string = "", num) {
      if (string.length <= num) {
        return string;
      }
      return string.slice(0, num);
    },
  }
};
</script>
<style scoped>
.image-container {
  display: flex;
  justify-content: center;
  align-items: center;
  height: 190px;
  /* Max desired height */
  width: 100%;
  overflow: hidden;
  border-radius: 10px;
  /* Optional: to see the bounds */
}

.image-container img {
  height: 100%;
  width: auto;
  object-fit: contain;
}

.node-image {
  border-radius: 10px;
}

.node-desc {
  padding: 0 10px 0 10px;
}

.text-node {
  text-align: center;
}

.text-node .text-subtitle-1 {
  font-family: "Plus Jakarta Sans", sans-serif !important;
}

.icon-block {
  background-color: #8866ff !important;
  color: #0D1117;
  border-radius: 50%;
  width: 35px;
  height: 35px;
}

.custom-card {
  border: 1px solid #8866ff60 !important;
  box-shadow: 0 0 10px #8866ff80 !important;
}

.v-card__text,
.v-card__title {
  word-break: normal;
  /* maybe !important  */
}
</style>